export default "__VITE_ASSET__BCHBPkTT__"